import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#b52a4e",
      primaryHover: "#a22546",
    },
    logoImage: logo,
    backend: "https://echo.epaper-publishing-one.de/ug/",
    directory: "/ug/kiosk",
    header: {
      customer: "",
      lineHeader: true,
      title: "Unsere Generation",
    },
    info: [
      {
      text: 'Impressum',
      link: 'http://www.seniormedia.at/kontakt/'
    },
  ],

  };